import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { UserAccountRoleEnum } from '../../api/types';
import { ISessionAppState } from '../../app/session/reducer';
import { ApplicationState } from '../../app/store';
import { AuthHelper } from '../../helpers/AuthHelper';
import { ERouterPath } from './ERouterPath';

interface IGuardedRouteProps extends RouteProps {
  requireDossier?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function GuardedRoute({ requireDossier, component, render, ...rest }: IGuardedRouteProps): JSX.Element {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const { dossier, user } = useSelector<ApplicationState, ISessionAppState>(state => state.session);

  useEffect(() => {
    AuthHelper.isAuthenticated()
      .then(isAuthenticated => {
        if (!isAuthenticated) {
          console.warn('User needs to be authenticated to access this route.');
        }
        setAuthenticated(isAuthenticated);
      })
      .catch(err => {
        console.error('Failed to get if user is authenticated', err);
        setAuthenticated(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (!loading && authenticated && requireDossier && !dossier) {
    if (user && [UserAccountRoleEnum.adminCaregiver, UserAccountRoleEnum.caregiver].includes(user.accountRole)) {
      return <Route {...rest} component={() => <Redirect to={{ pathname: ERouterPath.personalDossiers }} />}/>;
    } else if (user && user.accountRole === UserAccountRoleEnum.administration) {
      return <Route {...rest} component={() => <Redirect to={{ pathname: ERouterPath.allDossiers }} />}/>;
    } else {
      return <Route {...rest} component={() => <Redirect to={{ pathname: ERouterPath.selectFile }} />}/>;
    }
  } else if (!loading && !authenticated) {
    return <Route {...rest} component={() => <Redirect to={{ pathname: ERouterPath.login }} />}/>;
  } else if (!loading && authenticated) {
    return <Route {...rest} component={component}/>;
  }

  return <Route {...rest} component={() => <div></div>}/>;
}

export default GuardedRoute;
